/* eslint-disable import/extensions */
/* eslint-disable import/no-unresolved */
import Vue from 'vue'
import VueRouter from 'vue-router'
import { canNavigate, isAllowed } from '@/plugins/acl/routeProtection'
import useCryptoJs from '@/@core/utils/useCryptoJs'
import apps from './apps'
import dashboard from './dashboard'
import pages from './pages'
import userInterface from './user-interface'
import views from './views'

Vue.use(VueRouter)

const { decryptData } = useCryptoJs()

const deepLinksRoutes = ['video_detail', 'match_detail', 'g', 'l', 'w']

// Comparar por segmento y no por substring: '/download'.includes('l') es true y dejaba
// la pantalla en blanco a cualquier URL desconocida con una 'l' o una 'g'.
const includesDeepLinksRoutes = to => {
  const [firstSegment] = to.path.split('/').filter(Boolean)

  return deepLinksRoutes.includes(firstSegment)
}

// const redirectToBase = () => {
//  const data = JSON.parse(localStorage.getItem('userData'))
//  const userData = decryptData(data)
//  const userRole = userData && userData.user_role ? userData.user_role : null

// if (userRole === 'admin' || userRole === 'Player' || userRole === 'A' || userRole === 'F' || userRole === 'R') {
//   if (userData && userData.views_ids && userData.views_ids.length && userData.views_ids.includes(1)) {
//     return { name: 'views-facility-list' } // dashboard-crm
//   }

//   return { name: 'views-facility-list' } // welcome page
// }

// if (userRole === 'client') return { name: 'views-welcome' }

// return { name: 'views-facility-list' } // 'auth-login'
// }

// Un deep link que no matcheó ninguna ruta web (el SO no pudo abrir la app) va al store.
// Devolver null dejaba la navegación sin ruta y la pantalla en blanco.
const redirectToNotAuthorized = to => {
  if (to && includesDeepLinksRoutes(to)) return { name: 'fallback-links' }

  return { name: 'misc-not-authorized' }
}

const redirectTo404 = to => {
  if (to && includesDeepLinksRoutes(to)) return { name: 'fallback-links' }

  return { name: 'error-404' }
}

// DISABLED: /game/redirect route
// const redirectToGame = async to => {
//   if (to.path.includes('game/redirect') || to.path.includes('g/redirect')) {
//     const userLogged = await JSON.parse(localStorage.getItem('userData'))
//     const privateService = !!userLogged
//     let response = null

//     if (privateService) {
//       if (to.params.team) {
//         response = await getMatchGameCode(to.params.code, to.params.team)
//       } else {
//         response = await getMatchGameCode(to.params.code)
//       }
//     } else if (to.params.team) {
//       response = await getMatchGameOpenCode(to.params.code, to.params.team)
//     } else {
//       response = await getMatchGameOpenCode(to.params.code)
//     }

//     if (response.ok) {
//       const { data } = response
//       await customDeepLink('match', data.match_id)
//     }
//   }
// }

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('@/views/FallbackLinks.vue'),
    meta: {
      layout: 'blank',
      resource: 'Public',
      allow: true,
    },
  },
  {
    path: '/error-404',
    name: 'error-404',
    component: () => import('@/views/Error404.vue'),
    meta: {
      layout: 'blank',
      resource: 'Public',
    },
  },
  {
    path: '/fallback_links',
    name: 'fallback-links',
    component: () => import('@/views/FallbackLinks.vue'),
    meta: {
      layout: 'blank',
      resource: 'Public',
      allow: true,
    },
  },
  {
    path: '/download',
    name: 'download-app',
    component: () => import('@/views/FallbackLinks.vue'),
    meta: {
      layout: 'blank',
      resource: 'Public',
      allow: true,
    },
  },
  {
    path: '/deep-link-redirect',
    name: 'deep-link-redirect',
    component: () => import('@/views/DeepLinkRedirect.vue'),
    meta: {
      layout: 'blank',
      resource: 'Public',
      allow: true,
    },
  },
  {
    path: '/l/r/:id',
    name: 'deep-link-video',
    component: () => import('@/views/FallbackLinks.vue'),
    meta: {
      layout: 'blank',
      resource: 'Public',
      allow: true,
    },
  },
  {
    path: '/l/g/:id',
    name: 'deep-link-match',
    component: () => import('@/views/FallbackLinks.vue'),
    meta: {
      layout: 'blank',
      resource: 'Public',
      allow: true,
    },
  },
  {
    path: '/l/s/*',
    name: 'deep-link-schedule',
    component: () => import('@/views/FallbackLinks.vue'),
    meta: {
      layout: 'blank',
      resource: 'Public',
      allow: true,
    },
  },
  {
    path: '/login',
    name: 'auth-login',
    component: () => import('@/views/Login.vue'),
    meta: {
      layout: 'content',
      resource: 'Public',
      redirectIfLoggedIn: true,
    },
  },
  {
    path: '/forgot-password',
    name: 'auth-forgot-password',
    component: () => import('@/views/ForgotPasswordLanding.vue'),
    meta: {
      layout: 'content',
      resource: 'Public',
      redirectIfLoggedIn: true,
    },
  },
  {
    path: '/login-phone-email',
    name: 'auth-login-phone-email',
    component: () => import('@/views/LoginPhoneEmail.vue'),
    meta: {
      layout: 'content',
      resource: 'Public',
      redirectIfLoggedIn: true,
    },
  },
  {
    path: '/access-code',
    name: 'auth-access-code',
    component: () => import('@/views/AccessCode.vue'),
    meta: {
      layout: 'content',
      resource: 'Public',
      redirectIfLoggedIn: true,
    },
  },
  {
    path: '/confirmation-code',
    name: 'auth-confirmation-code',
    component: () => import('@/views/ConfirmationCode.vue'),
    meta: {
      layout: 'content',
      resource: 'Public',
      redirectIfLoggedIn: true,
    },
  },
  {
    path: '/is-this-you',
    name: 'auth-is-this-you',
    component: () => import('@/views/IsThisYou.vue'),
    meta: {
      layout: 'content',
      resource: 'Public',
      redirectIfLoggedIn: true,
    },
  },
  {
    path: '/create-account',
    name: 'auth-create-account',
    component: () => import('@/views/CreateAccount.vue'),
    meta: {
      layout: 'content',
      resource: 'Public',
      redirectIfLoggedIn: true,
    },
  },
  {
    path: '/match-detail/:code',
    name: 'match-detail',
    component: () => import('@/views/match-detail/MatchDetail.vue'),
    meta: {
      layout: 'blank',
      resource: 'Public',
      allow: true,
    },
  },

  // component: () => import('@/views/landing/Landing.vue'),
  // remove team
  // component: () => import('@/views/game/Game.vue'),
  // DISABLED: /g route
  // {
  //   path: '/g/:code/:team?',
  //   name: 'public',
  //   component: () => import('@/views/matches/Matches.vue'),
  //   meta: {
  //     layout: 'content',
  //     resource: 'Public',
  //     allow: true,
  //   },
  // },

  {
    path: '/matches',
    name: 'public',
    component: () => import('@/views/matches/Matches.vue'),
    meta: {
      layout: 'content',
      resource: 'Public',
      allow: true,
    },
  },

  // remove team
  // component: () => import('@/views/game/Game.vue'),
  // DISABLED: /game route
  // {
  //   path: '/game/:code/:team?',
  //   name: 'match',
  //   component: () => import('@/views/matches/Matches.vue'),
  //   meta: {
  //     layout: 'content',
  //     resource: 'Public',
  //     allow: true,
  //   },
  // },

  // Pickup
  {
    path: '/p/:code/:team?',
    name: 'pickup',
    component: () => import('@/views/pickup/Pickup.vue'),
    meta: {
      layout: 'content',
      resource: 'Public',
      allow: true,
    },
  },

  // DISABLED: /game/redirect route
  // {
  //   path: '/game/redirect/:code/:team?',
  //   name: 'game-redirect',
  //   meta: {
  //     layout: 'content',
  //     resource: 'Public',
  //     allow: true,
  //   },
  // },

  // DISABLED: /g/redirect route
  // {
  //   path: '/g/redirect/:code/:team?',
  //   name: 'game-redirect',
  //   meta: {
  //     layout: 'content',
  //     resource: 'Public',
  //     allow: true,
  //   },
  // },

  // remove team
  {
    path: '/views/pay-booking/:selected/:code/:team?',
    name: 'pay-booking',
    component: () => import('@/views/pay-booking/PayBooking.vue'),
    meta: {
      layout: 'content',
      resource: 'Public',
      allow: true,
    },
  },

  {
    path: '/views/public-facily-list',
    name: 'views-public-facility-list',
    component: () => import('@/views/facilities/Facilities.vue'),
    meta: {
      layout: 'content',
      resource: 'Public',
      redirectIfLoggedIn: true,
    },
  },
  {
    path: '/views/private-facily-list',
    name: 'views-private-facility-list',
    component: () => import('@/views/facilities/Facilities.vue'),
    meta: {
      layout: 'content',
      resource: 'Public',
      allow: true,
    },
  },
  {
    path: '/video-highlight-app/:user/:hash',
    name: 'video-highlight-app',
    component: () => import('@/views/video-highlight-app/VideoHighlightApp.vue'),
    meta: {
      layout: 'blank',
      resource: 'Public',
      allow: true,
    },
  },
  {
    // Waiver por QR (ticket 10): el token de la reserva ES la auth. Light,
    // noindex, sin layout de app. Se embebe en un iframe desde el Manager
    // ("Firmar aca") — el nginx de /w/ tiene que permitir frame-ancestors.
    path: '/w/:token',
    name: 'waiver-sign',
    component: () => import('@/views/waiver/WaiverSign.vue'),
    meta: {
      layout: 'blank',
      resource: 'Public',
      allow: true,
    },
  },
  {
    // "¿Qué te pareció esta funcionalidad?": destino de las caritas de los
    // mails (fastapi feedback_block). El token firmado es la auth; `?r=1..3`
    // es la carita tocada y se guarda al cargar.
    path: '/l/feedback/:token',
    name: 'feature-feedback',
    component: () => import('@/views/feedback/FeatureFeedback.vue'),
    meta: {
      layout: 'blank',
      resource: 'Public',
      allow: true,
    },
  },
  {
    path: '/r/:hash',
    name: 'recording',
    component: () => import('@/views/watch-recording/WatchRecording.vue'),
    meta: {
      layout: 'blank',
      resource: 'Public',
      allow: true,
    },
  },
  {
    path: '/rv/:code/:team?',
    name: 'reservation',
    component: () => import('@/views/matches/Matches.vue'),
    meta: {
      layout: 'blank',
      resource: 'Public',
      allow: true,
    },
  },

  // remove team
  {
    path: '/rvc/:code/:team?',
    name: 'choose-team',
    component: () => import('@/views/choose-team/ChooseTeam.vue'),
    meta: {
      layout: 'blank',
      resource: 'Public',
      allow: true,
    },
  },

  {
    path: '/profile-picture/:code/:team?',
    name: 'profile-picture',
    component: () => import('@/views/profile-picture/ProfilePicture.vue'),
    meta: {
      layout: 'blank',
      resource: 'Public',
      allow: true,
    },
  },

  {
    path: '/video-cancelled',
    name: 'video-cancelled',
    component: () => import('@/views/VideoCancelled.vue'),
    meta: {
      layout: 'content',
      resource: 'Public',
      redirectIfLoggedIn: true,
    },
  },
  {
    path: '/video-not-available',
    name: 'video-not-available',
    component: () => import('@/views/VideoNotAvailable.vue'),
    meta: {
      layout: 'content',
      resource: 'Public',
      allow: true,
    },
  },
  {
    path: '/reservation-not-found',
    name: 'reservation-not-found',
    component: () => import('@/views/ReservationNotFound.vue'),
    meta: {
      layout: 'content',
      resource: 'Public',
      allow: true,
    },
  },
  {
    path: '/match-not-found',
    name: 'match-not-found',
    component: () => import('@/views/MatchNotFound.vue'),
    meta: {
      layout: 'content',
      resource: 'Public',
      allow: true,
    },
  },
  {
    path: '/test',
    name: 'test',
    component: () => import('@/views/Test.vue'),
    meta: {
      layout: 'blank',
      resource: 'Public',
      allow: true,
    },
  },
  {
    path: '/register',
    name: 'auth-register',
    component: () => import('@/views/Register.vue'),
    meta: {
      layout: 'blank',
      resource: 'Public',
      redirectIfLoggedIn: true,
    },
  },
  {
    path: '/forgot-password-2',
    name: 'auth-forgot-password-2',
    component: () => import('@/views/ForgotPassword.vue'),
    meta: {
      layout: 'blank',
      resource: 'Public',
      redirectIfLoggedIn: true,
    },
  },
  {
    path: '/i/:code',
    name: 'app-invitation',
    component: () => import('@/views/AppInvitation.vue'),
    meta: {
      layout: 'blank',
      resource: 'Public',
    },
  },
  {
    path: '/app-redirect/:playback',
    name: 'app-redirect',
    component: () => import('@/views/AppRedirect.vue'),
    meta: {
      layout: 'blank',
      resource: 'Public',
    },
  },
  {
    path: '/page-not-found',
    name: 'page-not-found',
    component: () => import('@/views/VideoNotFound.vue'),
    meta: {
      layout: 'blank',
      resource: 'Public',
    },
  },
  {
    path: '/share/:playback/:username?',
    name: 'share',
    component: () => import('@/views/VideoHighlight.vue'),
    meta: {
      layout: 'blank',
      resource: 'Public',
    },
  },
  {
    path: '/vh/:playback',
    name: 'vh',
    component: () => import('@/views/VideoHighlight.vue'),
    meta: {
      layout: 'blank',
      resource: 'Public',
    },
  },
  {
    path: '/highlight/:playback/:username?',
    name: 'video-highlight',
    component: () => import('@/views/VideoHighlight.vue'),
    meta: {
      layout: 'blank',
      resource: 'Public',
    },
  },
  // Public pages moved from the retired Console (console.fanaty.com redirects
  // these paths here). /app-reditect keeps Console's typo for links already out.
  {
    path: '/field-app/:id',
    name: 'field-app',
    component: () => import('@/views/FieldApp.vue'),
    meta: {
      layout: 'blank',
      resource: 'Public',
    },
  },
  {
    path: '/field-not-found',
    name: 'field-not-found',
    component: () => import('@/views/FieldNotFound.vue'),
    meta: {
      layout: 'blank',
      resource: 'Public',
    },
  },
  {
    path: '/video/:playback/:username?',
    name: 'video-app',
    component: () => import('@/views/VideoApp.vue'),
    meta: {
      layout: 'blank',
      resource: 'Public',
    },
  },
  {
    path: '/va/:playback',
    name: 'va',
    component: () => import('@/views/VideoApp.vue'),
    meta: {
      layout: 'blank',
      resource: 'Public',
    },
  },
  {
    path: '/video-share/:playback',
    name: 'video-share',
    component: () => import('@/views/VideoShare.vue'),
    meta: {
      layout: 'blank',
      resource: 'Public',
    },
  },
  {
    path: '/video-not-found',
    name: 'video-not-found',
    component: () => import('@/views/VideoNotFound.vue'),
    meta: {
      layout: 'blank',
      resource: 'Public',
    },
  },
  {
    path: '/app-reditect/:playback',
    name: 'app-reditect',
    component: () => import('@/views/AppRedirect.vue'),
    meta: {
      layout: 'blank',
      resource: 'Public',
    },
  },
  ...dashboard,
  ...userInterface,
  ...apps,
  ...pages,
  ...views,
  {
    path: '*',
    redirect: redirectTo404,
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
})

// ? Router Before Each hook: https://router.vuejs.org/guide/advanced/navigation-guards.html
router.beforeEach(async (to, _, next) => {
  const data = JSON.parse(localStorage.getItem('userData'))
  const userData = decryptData(data)
  const isLoggedIn = userData && userData.access_token && localStorage.getItem('userAbility')

  const allow = !isAllowed(to, userData ? userData.views_ids : [])
  const canNav = !canNavigate(to)

  if (canNav || allow) {
    // Si es un deep link permitido, dejamos pasar aunque no esté logueado
    if (to && includesDeepLinksRoutes(to)) return next()

    // Redirect to login if not logged in
    if (!isLoggedIn) return next({ name: 'views-facility-list' })

    // If logged in => not authorized
    return next(redirectToNotAuthorized(to))
  }

  // DISABLED: /g/redirect route
  // if (to.path.includes('game/redirect') || to.path.includes('g/redirect')) {
  //   await redirectToGame(to)

  //   if (to.params.code && to.params.team) return next(`/game/${to.params.code}/${to.params.team}`)
  //   if (to.params.code) return next(`/game/${to.params.code}`)
  // }

  // Redirect if logged in
  // if (to.meta.redirectIfLoggedIn && isLoggedIn) {
  //   if (to.params.code && to.params.team) return next(`/game/${to.params.code}/${to.params.team}`)
  //   if (to.params.code) return next(`/game/${to.params.code}`)

  //   next('/')
  // }

  return next()
})

export default router
